import React from "react";

const Offers = () => {
  return (
    <div className="max-w-[900px] gap-x-8 m-auto px-4 py-12 flex flex-wrap justify-between">
      <p className="text-lg font-bold text-gray-700 cursor-pointer">
        Booking Incentives
      </p>
      <p className="text-lg font-bold text-gray-700 cursor-pointer">
        Competitive Rates
      </p>
      <p className="text-lg font-bold text-gray-700 cursor-pointer">
        Book With Flexibility
      </p>
      <p className="text-lg font-bold text-gray-700 cursor-pointer">
        Trip Insurance
      </p>
    </div>
  );
};

export default Offers;
